import * as React from 'react'
import styled from 'styled-components'

import * as S from '../../../../styles'

type SelectButtonProps = {
    isOpen: boolean
    borderless?: boolean
    className?: string
    disabled?: boolean
    id: string
    onClick: () => void
    status?: 'default' | 'focused' | 'error'
    children?: React.ReactNode
}

function SelectButtonComponent({
    isOpen,
    borderless,
    className,
    disabled,
    id,
    onClick,
    status,
    children
}: SelectButtonProps): React.ReactElement<SelectButtonProps> {
    return (
        <S.form.select.Button
            className={className}
            borderless={borderless}
            type="button"
            disabled={disabled}
            onClick={onClick}
            status={status}
            tabIndex={0}
            id={id}
            aria-expanded={isOpen}
        >
            <S.form.select.Label>{children}</S.form.select.Label>
            <S.form.select.CaretDown aria-hidden={true} focusable={false} />
        </S.form.select.Button>
    )
}

export const SelectButton = styled(SelectButtonComponent)<SelectButtonProps>``
